import { render, staticRenderFns } from "./FormBoxFile.vue?vue&type=template&id=3ca6e8f2&"
import script from "./FormBoxFile.vue?vue&type=script&lang=js&"
export * from "./FormBoxFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports